/**
 * LoadMore controller.
 *
 * This class controls the load more functionalilty.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class LoadMore
 */
export default class LoadMore {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

        // Current pagination number in.
        this.page = 0;

        // Max number of pages available.
        this.maxPage = 0;
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
    }

    /**
     * All common events
     * @return {void}
     */
    events() {
    }

    /**
     * Set up required class variables and call getPosts.
     *
     * @param {obj} e Load more click event.
     */
    loadMore( e ) {

        this.initLoadMore( e );

        // Increment this.page and call getPosts.
        this.page++;
        this.getPosts();
    }

    /**
     * Set up required class variables.
     *
     * @param {*} e Load more click event.
     */
    initLoadMore( e ) {
        if ( ! this.page ) {

            this.loadMoreBtn = e.target;

            // Make sure that the actual load more element was clicked, and not a child of it.
            if ( ! this.loadMoreBtn.getAttribute( 'data-page' ) ) {
                this.loadMoreBtn = e.target.parentNode;
            }

            const dataPage = this.loadMoreBtn.getAttribute( 'data-page' );
            this.page = dataPage ? parseInt( dataPage ) : 1;

            const dataMaxPage = this.loadMoreBtn.getAttribute( 'data-maxpage' );
            this.maxPage = dataMaxPage ? parseInt( dataMaxPage ) : 1;

            // Get info about what DustPress model should be used when retrieving data.
            this.dpModel = this.loadMoreBtn.getAttribute( 'data-model' );

            // Get info about what DustPress partial should be used when retrieving data.
            this.dpPartial = this.loadMoreBtn.getAttribute( 'data-partial' );

            // Define the element where the loaded posts will we appended to.
            const targetElementId = this.loadMoreBtn.getAttribute( 'data-target' );

            if ( targetElementId ) {
                this.targetElement = document.getElementById( targetElementId );
            }

            // Get the slug that will be used for the pagination url.
            const pageSlug = this.loadMoreBtn.getAttribute( 'data-pageslug' ) ;
            this.pageSlug = pageSlug ? pageSlug : 'page';

            // Define RegExp that will be used when checking if current pathname contains the pageslug.
            this.pageSlugPattern = new RegExp( this.pageSlug );

            // Define a RegExp that will be used when replacing the current path while manipulating history.
            // Matches when a string ends with the pageslug followed by a slash and digits (and possible a slash).
            // Example matches when pageslug is page: foo/page/2 and foo/bar/page/14/
            this.pageSlugReplacePattern = new RegExp( this.pageSlug + '\/(\\d+)\/?' );
        }
    }

    /**
     * Use DustPress JS to load more posts.
     */
    getPosts() {

        // Return early if model or partial missing
        if ( ! this.dpModel || ! this.dpPartial ) {
            return;
        }

        // Change the loading state.
        this.toggleLoader( true );

        // Manipulate history first to set the query automatically to the correct url.
        this.manipulateHistory();

        dp( this.dpModel, {
            tidy: true,
            partial: this.dpPartial,
        }).then( ( data ) => {
            this.successHandler( data.success );
        }).catch( ( error ) => {
            this.errorHandler( error );
        });
    }

    /**
     * .Manipulates browser history, appends data to DOM and toggles loading state.
     *
     * @param {mixed} data Data usually returned from a DustPress JS ajax request.
     */
    successHandler( data ) {

        // Replace the search results in the searchResultsContainer with the found results.. Also checking data variable. It might be false if
        // trying to get data from a DustPress model that does not exist.
        if ( this.targetElement && data ) {
            $( this.targetElement ).html( data );
        }

        // Change loading state. Call with loading state as false, so that the button gets removed if needed.
        this.toggleLoader( false );
    }

    /**
     * Handles failed DustPress JS request.
     *
     * @param {mixed} error Error returned by failed DustPress JS request.
     */
    errorHandler( error ) {
        this.toggleLoader( false );
        console.log( error );
    }

    /**
     * Manipulate the window history by adding or changing the page number in the url.
     */
    manipulateHistory() {

        // Check if history is supported in browser and required variables are set.
        if ( window.history && this.pageSlug && this.pageSlugPattern && this.pageSlugReplacePattern ) {

            let path = location.pathname;

            // Chek if the url contains a page and replace the current location with the new state.
            // We do not want the page in search result urls.

            // Remove pagination from current path.
            if ( this.pageSlugPattern.test( location.pathname ) ) {
                path = location.pathname.replace( this.pageSlugReplacePattern, '' );
            }

            // Remove possible slash from end of path
            path = path.replace( /\/$/, '' );

            // Add pagination to path.
            path = path + '/' + this.pageSlug + '/' + this.page + '/';

            // Get current base url
            let url = window.location.protocol + '//' + location.host + path;

            window.history.replaceState({}, '', url );
        }
    }

    /**
     * Changes the state of the loader.
     *
     * @param {bool} isLoading The current loading state of the app. If false, checks if the button should be removed.
     */
    toggleLoader( isLoading = true ) {
        if ( this.loadMoreBtn ) {

            // Toggle button loading state.
            this.loadMoreBtn.classList.toggle( 'is-loading' );

            // Hide load more button if there is nothing more to load.
            if ( ! isLoading && ( this.page >= this.maxPage ) ) {
                this.loadMoreBtn.parentNode.removeChild( this.loadMoreBtn );
            }
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}
